import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { createModal } from "react-modal-promise";
import { toast } from "react-toastify";
import { ProposalType } from "src/redux/projects";

interface Props {
  proposalType: ProposalType;
  // open and close are given via react-modal-promise HOC
  open: boolean;
  close: (data?: {
    text: string | null;
    emailAdresses: string[] | null;
  }) => void;
}

interface State {
  text: string;
  mail: string;
  emailAdresses: string[];
}

type PropsWithNamespaces = Props & WithNamespaces;

class ShareModal extends React.Component<PropsWithNamespaces, State> {
  state: State = {
    text: "",
    mail: "",
    emailAdresses: []
  };
  componentWillMount() {
    this.setState({ text: this.setTextWithProposalType() });
  }
  setTextWithProposalType = () => {
    switch (this.props.proposalType) {
      case "POV":
        return (
          this.props.t("proposal.pov.msgShare") +
          "\n" +
          this.props.t("proposal.msgShareCourtesy")
        );
      case "Artwork":
        return (
          this.props.t("proposal.artwork.msgShare") +
          "\n" +
          this.props.t("proposal.msgShareCourtesy")
        );
      case "PlanDecoration":
        return (
          this.props.t("proposal.deco.msgShare") +
          "\n" +
          this.props.t("proposal.msgShareCourtesy")
        );
      default:
        return "";
    }
  };
  onCommentChange = e => {
    this.setState({ text: e.target.value });
  };
  removeMail = index => {
    const newemailAdresses = this.state.emailAdresses.filter(i => i !== index);
    this.setState({
      emailAdresses: newemailAdresses
    });
    return;
  };
  onMailChange = e => {
    this.setState({ mail: e.target.value });
  };
  setemailAdresses = mail => {
    // Regex for email validation
    const emailReg = /.+@.+/;
    // test email validation
    if (emailReg.test(mail)) {
      // add new mail in emailAdresses array
      const emailAdressesCopy = this.state.emailAdresses.slice();
      emailAdressesCopy.push(mail);
      this.setState({
        mail: "",
        emailAdresses: emailAdressesCopy
      });
    } else {
      toast.error(this.props.t("proposal.errorValidMailShare"));
    }
  };
  onKeyPressMail = e => {
    if (e.key === "Enter" || e.key === " ") {
      this.setemailAdresses(this.state.mail.replace(/\s/g, ""));
    }
  };
  /**
   * Dismiss a modal: return null as modal result
   */
  dismiss = () => this.props.close();

  /**
   * Transmit modal result while closing it
   */
  transmit = () =>
    this.props.close({
      emailAdresses: this.state.emailAdresses,
      text: this.state.text
    });
  onMailBlur = () => {
    this.setemailAdresses(this.state.mail.replace(/\s/g, ""));
  };
  render() {
    /* This modal should be in a promise, so it's always open */
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.dismiss}
        className="comment-modal share-modal"
      >
        <ModalHeader toggle={this.dismiss}>
          <span className="flex-1">{this.props.t("shareModal.title")}</span>
        </ModalHeader>
        <ModalBody>
          <p>{this.props.t("shareModal.to")}</p>
          <input
            placeholder={this.props.t("shareModal.email")}
            onChange={this.onMailChange}
            value={this.state.mail}
            type="text"
            onKeyPress={this.onKeyPressMail}
            onBlur={this.onMailBlur}
            className="w-100 pt-1 pb-1"
          />
          <div className="emailAdresses mt-2">
            {this.state.emailAdresses.map((item, index) => (
              <span className="mr-1" key={index}>
                {item}
                <span onClick={e => this.removeMail(item)}>x</span>
              </span>
            ))}
          </div>
          <textarea
            className="mt-3 comment-modal-textarea"
            placeholder="..."
            value={this.state.text}
            onChange={this.onCommentChange}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.dismiss}>
            {this.props.t("commentModal.cancel")}
          </Button>{" "}
          <Button
            disabled={!this.state.text || this.state.emailAdresses.length === 0}
            color="primary"
            onClick={this.transmit}
          >
            {this.props.t("shareModal.validate")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default createModal(withNamespaces()(ShareModal));



// WEBPACK FOOTER //
// ./src/components/ShareModal.tsx